/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable max-len */
import React, { useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { TranslatorContext, FormattedMessage } from '@jutro/locale';
import { CheckboxField, Link } from '@jutro/components';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { doesUrlExist } from 'gw-portals-url-js';
import messages from './TnCComponent.messages';
import styles from './TnCComponent.module.scss';

const TnCComponent = ({
    value, onValueChange, label, id, path, isCustomLabel
}) => {
    const translator = useContext(TranslatorContext);
    const tncLink = _.get(appConfig, `tdic.termsOfUseEnternalLink.${process.env.NODE_ENV}`, _.get(appConfig, 'tdic.termsOfUseEnternalLink.development'));

    const openTOU = useCallback((event) => {
        event.preventDefault();
        if (doesUrlExist(tncLink)) {
            window.open(tncLink, '_blank');
        } else {
            window.history.push('/error');
        }
    }, [tncLink]);

    const getMessage = useCallback(() => {
        const labelId = _.get(label, 'id', '');
        // Check if it's the ACH message with autopay (has two links)
        const isAutopayLabel = labelId.includes('tncBillingAch') || labelId.includes('Autopay');

        // If ACH message (with autopay), use two links
        if (isAutopayLabel) {
            return (
                <FormattedMessage
                    {...label}
                    values={{
                        link: (
                            <Link
                                onClick={(event) => openTOU(event)}
                                className={styles.tncLink}
                                href="/"
                            >
                                {translator(messages.termsOfUse)}
                            </Link>
                        ),
                        link1: (
                            <Link
                                className={styles.tncLink}
                                to="/billing-summary"
                            >
                                {translator(messages.autopay)}
                            </Link>
                        ),
                        br: <br />
                    }}
                />
            );
        }

        // For Credit Card - single link (Terms of Use)
        return (
            <FormattedMessage
                {...label}
                values={{
                    link: (
                        <Link
                            onClick={(event) => openTOU(event)}
                            className={styles.tncLink}
                            href="/"
                        >
                            {translator(messages.termsOfUse)}
                        </Link>
                    )
                }}
            />
        );
    }, [label, openTOU, translator]);

    return (
        <div className={styles.tncCheckbox}>
            <CheckboxField
                id={id}
                label={!isCustomLabel && translator(label)}
                labelPosition="left"
                size="large"
                showInlineLabel
                onValueChange={onValueChange}
                required
                className={styles.tncClassContainer}
                value={value}
                path={path}
            />
            {isCustomLabel && <span>{getMessage()}</span>}
        </div>
    );
};

TnCComponent.propTypes = {
    value: PropTypes.bool.isRequired,
    onValueChange: PropTypes.func.isRequired,
    label: PropTypes.shape({
        id: PropTypes.string,
        defaultMessage: PropTypes.string
    }),
    id: PropTypes.string.isRequired,
    path: PropTypes.string,
    isCustomLabel: PropTypes.bool
};

TnCComponent.defaultProps = {
    path: '',
    label: undefined,
    isCustomLabel: false
};

export default TnCComponent;
